<template>
<div id="app" v-bind:class="{ standalone: isAppStandalone() }">
  <sign-up-modal />
  <video-modal />
  <format-detail-modal />
  <warning-modal />
  <pricing-modal />
  <intersection-modal />
  <payment-options-modal />
  <export-ad-modal />
  <user-input-modal />
  <vue-snotify></vue-snotify>
  <main :class="{'main-view': darkMode,'main-view--dark-mode': darkMode}" role="main">
    <main-navigation />
    <router-view />
    <main-footer />
  </main>
  <!-- The styles are important for this to appear over the modals -->
  <v-tour style="z-index: 10000; position: relative;" name="long_tour" :steps="long_tour_steps"></v-tour>
  <v-tour name="home_tour" :steps="home_tour_steps" :callbacks="homeCallbacks"></v-tour>
  <v-tour style="z-index: 10000; position: relative" name="config_tour" :steps="config_tour_steps" :callbacks="configCallbacks"></v-tour>
</div>
</template>

<script>
import SignUpModal from './components/modals/SignUp'
import VideoModal from './components/modals/Video'
import FormatDetailModal from './components/modals/FormatDetail'
import WarningModal from './components/modals/Warning'
import PricingModal from './components/modals/Pricing'
import PaymentOptionsModal from './components/modals/PaymentOptions'
import ExportAdModal from './components/modals/ExportAd'
import UserInputModal from './components/modals/UserInput'
import IntersectionModal from './components/modals/Intersection'
import { passback, close, allowBoostrapCall } from './lib/integration';
import router from './router'

export default {
  name: 'app',
  components: {
    SignUpModal,
    FormatDetailModal,
    WarningModal,
    PricingModal,
    PaymentOptionsModal,
    ExportAdModal,
    IntersectionModal,
    UserInputModal,
    VideoModal
  },
  created(){
    window.rootVM = this;
    allowBoostrapCall();
    let matches = location.hash.match(/p=([\w\.\/\%]+)/);
    if (matches) {
      let p = decodeURIComponent(matches[1])
      p = p.split('/');
      this.$router.push('/configuration/' + p[1] + '/' + p[2]);
    }
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
          isEscape = (evt.key == "Escape" || evt.key == "Esc");
      } else {
          isEscape = (evt.keyCode == 27);
      }
      if (isEscape) {
          close()
      }
    };
  },
  methods: {
    show (name) {
      this.$modal.show(name)
    },
    onStopHomeTour () {
      let payload = {
        name: 'home_tour',
        value: 'finished'
      };
      if (this.$tours['home_tour'].currentStep === this.$tours['home_tour'].steps.length - 1) {
        this.updatePreferences(payload);
      }
    },
    onStopConfigTour () {
      let payload = {
        name: 'ad_creation_tour',
        value: 'finished'
      };
      if (this.$tours['config_tour'].currentStep === this.$tours['config_tour'].steps.length - 1) {
        this.updatePreferences(payload);
      }
    },
    updatePreferences(payload) {
      this.$store.dispatch('updatePreferences', {userId: this.$store.state.me.id, payload: payload});
    },
    addUserToAccount () {
      this.$store.dispatch('addUserToAccount', {token: localStorage.account_token})
    },
  },
  data () {
    return {
      homeCallbacks: {
        onStop: this.onStopHomeTour
      },
      configCallbacks: {
        onStop: this.onStopConfigTour
      },
      home_tour_steps: [
        {
          target: '[data-v-home-step="0"]',
          content: 'Welcome to ParkAve! <br> Let\'s take a quick tour.'
        },
        {
          target: '[data-v-home-step="1"]',
          content: 'ParkAve is all about easy-to-create banner formats that advertisers love.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-home-step="3"]',
          content: 'Click here to build a creative ...',
          params: {
            placement: 'top'
          }
        },
        {
          target: '[data-v-home-step="4"]',
          content: '... and click here to see an example of that creative.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-home-step="5"]',
          content: 'All of your ads are saved and viewable here.',
          params: {
            placement: 'bottom'
          }
        },
      ],
      config_tour_steps: [
        {
          target: '[data-v-config-step="0"]',
          content: 'This is where you can configure your creative.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-config-step="1"]',
          content: 'Change the content of the creative by customizing these fields.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '[data-v-config-step="3"]',
          content: 'This is a live preview of your creative — it updates while you\'re editing.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '[data-v-config-step="4"]',
          content: 'You can preview the ad in different sizes here.',
          params: {
            placement: 'bottom'
          }
        },
      ],
      long_tour_steps: [
        {
          target: '[data-v-long-step="0"]',
          content: `Welcome to ParkAve! <br> Let's show you around!`
        },
        {
          target: '[data-v-long-step="1"]',
          content: `ParkAve has a massive list of <br> innovative ad formats to choose from.`,
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-long-step="2"]',
          content: 'You can access your account settings and <br> switch between your accounts from this <br> dropdown menu.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-long-step="3"]',
          content: 'Here is one of the ad formats <br> you have the ability of creating.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '[data-v-long-step="4"]',
          content: 'The <strong>View Demo</strong> button shows useful <br> information and a media kit for the format.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-long-step="5"]',
          content: 'Click Here to start <br> creating a format and to continue the tour!',
          params: {
            placement: 'top'
          }
        },
        {
          target: '[data-v-long-step="6"]',
          content: 'Keep Going!',
          params: {
            placement: 'right'
          }
        },
        {
          target: '[data-v-long-step="7"]',
          content: 'This is the config <br> where you can customize the ad to your liking',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-long-step="8"]',
          content: 'These are the custom fields <br> you can use to change the ad.',
          params: {
            placement: 'top'
          }
        },
      ]
    }
  },
  beforeCreate: function () {
    if (this.$route.query.invite) {
      localStorage.account_token = this.$route.query.invite;
    }
    if (this.$route.query.signup_token) {
      localStorage.signup_token = this.$route.query.signup_token;
    }
    if (this.$route.query.password) {
      localStorage.password_token = this.$route.query.password;
    }
    if (this.$route.query.coupon) {
      localStorage.coupon_token = this.$route.query.coupon;
    }
    if (this.$route.query.update_confirmation) {
      localStorage.update_confirmation = this.$route.query.update_confirmation;
    }
    if (this.$route.query.update_request_approval) {
      localStorage.update_request_approval = this.$route.query.update_request_approval;
    }
    if (this.$route.query.update_request_denial) {
      localStorage.update_request_denial = this.$route.query.update_request_denial;
    }
    if (this.$route.query.referral) {
      localStorage.parkave_referral_code = this.$route.query.referral;
    }
    if (this.$route.query.partner) {
      localStorage.parkave_partner_code = this.$route.query.partner;
    }
  },
  mounted () {
    if (this.$route.query.auto_signup) {
      let email = this.$route.query.auto_signup;
      router.replace({...router.currentRoute,
        query: {
          auto_signup: undefined
        }
      })
      this.$modal.show('sign-up', {email: email});
    }
    if (localStorage.account_token || this.$route.query.invite) {
      if (!localStorage.token) {
        this.$modal.show('intersection');
      }
    }
    if (localStorage.parkave_referral_code) {
      router.replace({...router.currentRoute,
        query: {
          parkave_referral_code: undefined
        }
      })
      if (!localStorage.token) {
        this.$modal.show('intersection');
      }
    }
    if (localStorage.signup_token) {
      this.$store.dispatch('verifySignUp', {token: localStorage.signup_token})
    }
    if (localStorage.password_token) {
      this.$store.dispatch('users/verifyPassword', {token: localStorage.password_token})
    }
    if (localStorage.update_confirmation) {
      this.$store.dispatch('updates/confirm', { token: localStorage.update_confirmation })
    }
    if (localStorage.update_request_approval) {
      this.$store.dispatch('updates/approve', { token: localStorage.update_request_approval })
    }
    if (localStorage.update_request_denial) {
      this.$store.dispatch('updates/deny', { token: localStorage.update_request_denial })
    }
    if (this.$route.query.register) {
      if (localStorage.account_id && localStorage.token) {
        this.$modal.show('payment-options', this.$route.query.register)
      } else {
        this.$modal.show('intersection');
      }
    }
    if (this.$route.path == '/pricing') {
      if (localStorage.account_id && localStorage.token) {
        this.$modal.show('pricing');
      } else {
        this.$modal.show('intersection');
      }
    }
    if (localStorage.coupon_token) {
      if (!localStorage.account_id) {
        this.$modal.show('intersection');
      } else {
        this.$store.dispatch('coupons/getActive', localStorage.coupon_token).then((coupon) => {
          // Remove coupon from localstorage if the coupon doesn't exist
          if (!coupon) {
            localStorage.removeItem('coupon_token')
            this.$modal.hide('payment-options')
          }
        })
      }
    }
  },
  computed: {
    user_id () {
      return this.$store.state.me.id
    },
    darkMode () {
      return this.$route.name !== 'Demo' && this.$route.name !== 'EnterpriseForm' && this.$route.name !== 'UpdateSuccess'
    },
    account () {
      return this.$store.state.account.id
    }
  },
  watch: {
    'user_id': {
      handler (newVal) {
        if (newVal) { // check if userid is available
          if (localStorage.account_token) {
            this.addUserToAccount();
          }
        }
      },
      immediate: true // make this watch function is called when component created
    },
    'account': {
      handler (newVal) {
        if (this.$route.query.register) {
          this.$modal.hide('payment-options');
          this.$modal.hide('intersection');
          if (localStorage.account_id && localStorage.token) {
            this.$modal.show('payment-options', this.$route.query.register)
          } else {
            this.$modal.show('intersection');
          }
        }
        if (this.$route.path == '/pricing') {
          this.$modal.hide('pricing');
          this.$modal.hide('intersection');
          if (localStorage.account_id && localStorage.token) {
            this.$modal.show('pricing');
          } else {
            this.$modal.show('intersection');
          }
        }
        if (localStorage.coupon_token) {
          // this.$modal.hide('payment-options');
          // this.$modal.hide('intersection');
          if (localStorage.account_id && localStorage.token) {
            this.$modal.hide('intersection');
            this.$store.dispatch('coupons/getActive', localStorage.coupon_token).then((coupon) => {
              this.$modal.show('payment-options', {coupon})
            })
          } else {
            this.$modal.show('intersection');
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import 'scss/index';
@import 'scss/templates/app';
</style>



// WEBPACK FOOTER //
// src/App.vue